import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { X } from "lucide-react";
import {
  dismissAbandonedBanner,
  isCartAbandoned,
  openCart,
  selectAbandonedBannerDismissed,
  selectCartItems,
} from "../../store/cartSlice";

/**
 * AbandonedCartBanner
 * Sticky banner below the header when cart items have gone cold (15 min idle).
 */
export default function AbandonedCartBanner() {
  const dispatch = useDispatch();
  const items = useSelector(selectCartItems);
  const dismissed = useSelector(selectAbandonedBannerDismissed);

  const abandoned = isCartAbandoned() && items.length > 0 && !dismissed;

  if (!abandoned) return null;

  return (
    <div
      role="alert"
      style={{
        position: "fixed",
        top: "var(--header-h, 72px)",
        left: 0,
        right: 0,
        zIndex: 110,
        background: "linear-gradient(90deg, #6a00f4, #a100f2)",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        padding: "10px 20px",
        fontSize: 13,
        fontFamily: "'Inter', sans-serif",
        fontWeight: 500,
        boxShadow: "0 4px 20px rgba(106,0,244,0.35)",
        animation: "fade-up 0.4s ease-out",
        flexWrap: "wrap",
      }}
    >
      <span>🛒</span>
      <span>
        You left <strong>{items.length} item{items.length !== 1 ? "s" : ""}</strong> in your cart.
      </span>
      <button
        onClick={() => dispatch(openCart())}
        style={{
          background: "rgba(255,255,255,0.18)",
          border: "1px solid rgba(255,255,255,0.4)",
          color: "#fff",
          borderRadius: 8,
          padding: "4px 14px",
          fontSize: 12,
          fontWeight: 600,
          cursor: "pointer",
          flexShrink: 0,
        }}
      >
        View Cart
      </button>
      <button
        onClick={() => dispatch(dismissAbandonedBanner())}
        aria-label="Dismiss"
        style={{
          background: "none",
          border: "none",
          color: "rgba(255,255,255,0.7)",
          cursor: "pointer",
          padding: 4,
          marginLeft: 4,
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        <X size={15} />
      </button>
    </div>
  );
}
